import {get, patch} from "./common";

export const vendorGetClientReviews = async (page = 1, per_page = 10) => {
    try {
        return await get(`/vendor/client-review/index?page=${page}&per_page=${per_page}`);
    } catch (error) {
        return null;
    }
};

export const vendorGetSingleClientReview = async (reviewId) => {
    try {
        return await get(`/vendor/client-review/${reviewId}`);
    } catch (error) {
        return null;
    }
};

export const vendorClientReviewPatchUpdate = async (reviewId, field, value) => {
    try {
        return await patch(`/vendor/client-review/${reviewId}/update/${field}`, {[field]: value});

    } catch (error) {
        return null;
    }
};

export const vendorGetSingleClientReviewToken = async () => {
    try {
        return await get(`/token/generate?type=1`);
    } catch (error) {
        return null;
    }
};
